module.exports = __webpack_public_path__ + "img/mind_skeleton_time_3.66da953f.png";